<template>
	<div class="container">
		<div class="news-detail">
			<div class="nd-body">
				<div class="bread-nav">
					<span @click="navgoTo()">全部</span> > 播聘新闻 > <span class="txt-gray">{{objData.title}}</span>
				</div>
				<div class="nd-body-content">
					<div class="nd-body-view">
						<div class="nd-body-view-title">{{objData.title}}</div>
						<div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 播聘新闻</div>
						<div class="nd-body-view-content">{{objData.content}}</div>
						<div class="nd-body-view-content">
							<img src="../../../static/age.jpg" alt="map"/>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
							<div>{{objData.contenta}}</div>
							<div>{{objData.contenta1}}</div>
							<div>{{objData.contenta2}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
							<div>{{objData.contentb1}}</div>
							<div>{{objData.contentb2}}</div>
							<div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
							<div>{{objData.contentc1}}</div>
							<div>{{objData.contentc2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
							<div>{{objData.contentd1}}</div>
							<div>{{objData.contentd2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-of">
							<div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
							<div>下一篇：{{objData.next}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'showNewsAge',
		data(){
			return {
				id:'',
				objData:{
					title:`95后求职调查：程序员岗位最受青睐`,
					date:`2019年9月12日`,
					froms:`播聘`,
					next:`播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
					prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
					content:`近日，移动社交招聘平台大街网发布《95后求职意愿调查报告》。报告显示，程序员岗位对95后最具吸引力。而在所有互联网企业中，华为（Huawei）、字节跳动（ByteDance）、阿里巴巴（Alibaba）、腾讯（Tencent）组成HBAT格局，占据招聘第一梯队，成为95后最关注和满意度最高的互联网企业。`,
					subtitle:`程序员岗位最受青睐`,
					contenta:`大街网调查报告显示，编程/IT开发、运营、产品，是对95后最具有吸引力的前三类岗位。这不仅是95后期望从事的岗位，也是实际签约人数最多的岗位。在IT/互联网行业处于上升期的大背景下，高达46%的95后期望从事编程/开发岗位。`,
					contenta1:`与此同时，调研数据显示，95后实际薪资大多数出现在3k-8k这个范畴，而期望薪资大多为8k-12k，对薪资的期待值普遍高于现状。这意味着，即使在经济下行的趋势下，95后仍未降低对薪资的预期。`,
					contenta2:`在诸多影响95后求职的因素中，企业发展情况最为关键。约78%的95后认为，“公司业绩好有发展前景”是理想雇主的首要因素。95后也会因为产品影响力而对企业产生偏好，70%的人认为产品是企业实力的重要参考。`,

					subtitleb:`字节跳动、阿里、华为最受关注`,
					contentb1:`从95后在大街App的职位点击量可以看出，95后对字节跳动的关注度，已经超过阿里、腾讯等老牌互联网企业。字节跳动相关职位的点击量，在互联网企业中居冠，领先于第二名阿里巴巴10%，华为、腾讯分别位列第三、四位。`,
					contentb2:`报告指出，作为互联网行业的后起之秀，字节跳动成立7年以来，旗下今日头条、抖音、西瓜视频、火山小视频等产品快速发展，带来了对人才的强烈渴求。年轻的团队氛围和持续开发出年轻人普遍喜欢的产品，使得字节跳动的受关注程度不断升高。以往由BAT（百度、阿里、腾讯）引领的互联网格局，已被字节跳动打破一角。`,

					subtitlec:`HBAT的95后员工满意度超80%`,
					contentc1:`大街网针还对互联网企业员工满意度，进行了专门的调研。报告显示，互联网大厂95后员工满意程度排名前四的企业，依次是阿里、字节跳动、华为、腾讯；8成以上的95后对目前所处公司表示满意。阿里巴巴以86.1%的满意度居首，字节跳动以83.2%的满意度位居第二。字节跳动、华为、腾讯三家公司员工不满意度均低于5%。`,
					contentc2:`在具体的95后员工满意度细节指标上，HBAT均拥有较靠前的排名，华为、阿里、腾讯作为老牌企业，一直有较好的口碑，小巨头字节跳动近年奋起直追，在员工满意度方面有所突破，在企业发展前景、公司文化和团队氛围等方面领先。大街网指出，互联网大厂的95后，已经获得了优于同龄人的机遇，总体对目前所处公司满意度很高。`,
				}
			}
		},
		created(option) {
			this.init()
		},
		methods:{
			init(){
				let _this = this;
				_this.id = _this.$route.query.id || ``;
				
			},
			navgoTo(){
				this.$nav({path:`/show-news`},this)
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./show-news-age.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-news-age/show-news-age.vue